export default __webpack_public_path__ + "static/media/ViewIcon.fd4f3baf.svg";